import {TOGGLE_MENU} from "../action-types";

const initialState = false;
type actionType = {
    payload: boolean;
    type: string;
}
export default function(state = initialState, action: actionType) {
    switch (action.type) {
        case TOGGLE_MENU: {
            return action.payload;
        }
        default: {
            return state;
        }
    }
}
